//#Global Imports
import React from "react";
//#end Global Imports

//#Local Imports
import Button from "../../components/ui/Button";
import Typograpy from "../../components/ui/Typography";
import { IRemitterProps } from "./Remmiter";
import TrashBin from "../../assets/Icons/TrashBin";
import { CopyIcon } from "../../assets/Icons";
import ShareWhite from "../../assets/svg/share-white.svg"
//#end Local Imports

const RemitterDetails: React.FC<IRemitterProps.IRemitterDetailsProps> = ({
  remitterData,
  deleteRemitterHandler,
  handleTransactionUpdate,
  handleSelectedRemitter,
  handleResendKycLink,
  handleResendLink,
  catchKycLink,
  showToast,
}) => {

  const handleCopy = () => {
    if (catchKycLink) {
      navigator.clipboard.writeText(catchKycLink)
        .then(() => {
          console.log('Text copied to clipboard');
          // Optionally, show a success message to the user
          showToast && showToast("KYC Link Copied", "success")
        })
        .catch(err => {
          console.error('Failed to copy text: ', err);
          // Optionally, show an error message to the user
          showToast && showToast("KYC Link not Copied", "failure")
        });
    }
  };

  return (
    <div onClick={() => handleSelectedRemitter(remitterData?.id)}>
      <div className={`flex flex-col px-5 pb-5 mb-6 pt-7`}>
        <div className="flex items-center justify-between w-full pb-[22px]">
          <div className="flex flex-col gap-4">
            <Typograpy
              tagType="div"
              text="Remitter details"
              className="text-sm font-bold text-black"
            />
            <div className="flex items-center gap-1">
              <Typograpy tagType="div" text="Name : " className="text-sm font-normal text-black" />
              <Typograpy
                tagType="div"
                text={remitterData?.firstName + " " + remitterData?.lastName}
                className="text-sm font-normal text-black"
              />
            </div>
            <div className="flex items-center gap-1">
              <Typograpy
                tagType="div"
                text="Date of Birth : "
                className="text-sm font-normal text-black"
              />
              <Typograpy
                tagType="div"
                text={remitterData?.dob}
                className="text-sm font-normal text-black"
              />
            </div>
          </div>
          <div className="flex flex-col gap-4">
            <Typograpy
              tagType="div"
              text="Remitter Contact details"
              className="text-sm font-bold text-black"
            />
            <div className="flex items-center gap-1">
              <Typograpy tagType="div" text="Email : " className="text-sm font-normal text-black" />
              <Typograpy
                tagType="div"
                text={remitterData?.email}
                className="text-sm font-normal text-black"
              />
            </div>
            <div className="flex items-center gap-1">
              <Typograpy
                tagType="div"
                text="Phone No : "
                className="text-sm font-normal text-black"
              />
              <Typograpy
                tagType="div"
                text={remitterData?.phoneNumber}
                className="text-sm font-normal text-black"
              />
            </div>
          </div>
          <div className="flex flex-col gap-4">
            <Typograpy
              tagType="div"
              text="Remitter Address details"
              className="text-sm font-bold text-black"
            />
            <div className="flex items-center gap-1">
              <Typograpy
                tagType="div"
                text="Address : "
                className="text-sm font-normal text-black"
              />
              <Typograpy
                tagType="div"
                text={remitterData?.addressLine1 ? remitterData?.addressLine1 : "" + " " + remitterData?.addressLine2 ? remitterData?.addressLine2 : ""}
                className="text-sm font-normal text-black"
              />
            </div>
            <div className="flex items-center gap-1">
              <Typograpy tagType="div" text="City : " className="text-sm font-normal text-black" />
              <Typograpy
                tagType="div"
                text={remitterData?.city}
                className="text-sm font-normal text-black"
              />
            </div>
          </div>

          {!remitterData?.isDocVerified ? (
            <>
              <div className="flex flex-col items-start gap-2">
                <Typograpy
                  tagType="div"
                  text={`KYC Status : ${remitterData?.kycStatus}`}
                  className="text-xs font-normal text-[#646464]"
                />
                {/* <Typograpy
                  tagType="div"
                  text={`Send link on e-mail or mobile`}
                  className="text-xs font-normal text-black"
                /> */}
                <p className="text-xs font-normal text-black">
                  Send link on{" "}
                  <span className="font-bold">
                    e-mail {" "}
                  </span>
                  or{" "}
                  <span className="font-bold">
                    mobile.
                  </span>
                </p>
                <div className="flex items-center gap-2">
                  <Button
                    bgColor="bg-[#006EFF]"
                    fontStyle={{
                      fontFamily: "font-ssp",
                      fontSize: "text-base",
                      fontWeight: "font-semibold",
                      fontColor: "text-white",
                    }}
                    borderStyle={{
                      borderRadius: "rounded-md",
                    }}
                    className="p-2"
                    onClickHandler={() => {
                      handleResendKycLink(remitterData?.userKey)
                      showToast && showToast("KYC Link Sent to email and phone number of the remitter", "success")
                    }}
                  >
                    <img src={ShareWhite} className="px-1" alt="Share" />
                    SHARE LINK
                  </Button>
                  <div className="cursor-pointer" onClick={handleCopy}>
                    <CopyIcon />
                  </div>
                </div>
              </div>
            </>
          ) : null}
          <div onClick={() => deleteRemitterHandler(remitterData?.id)} className="cursor-pointer">
            <TrashBin fillColor="#DA0507" />
          </div>
        </div>
      </div>
    </div>
  );
};
export default RemitterDetails;
